import React, { Fragment } from "react";
import NoticeContent from "../../components/account/NoticeContent";
import Headbar from "../../components/Layout/Headbar";
import { isEmpty } from "../../common/cores";

const Notices = () => {
  return (
    <Fragment>
      <div id="layoutBody" style={{ paddingTop: "0px" }}>
        <div className="wrapper  lang_ko" id="bodyTemplate">
          <div id="contentTheme"></div>
          <Headbar />
          <div className="title_wrap">
            <div className="title_box">
              <div className="title">
                {isEmpty(window.lang["공지"]) ? "공지" : window.lang["공지"]}{" "}
              </div>
            </div>
          </div>
          <NoticeContent></NoticeContent>
        </div>
      </div>
    </Fragment>
  );
};

export default Notices;



// WEBPACK FOOTER //
// ./src/containers/Account/Notices.js